import ImageDeferrer from 'utils/ImageDeferrer';

window.addEventListener('load', () => {
  const imageElements = document.querySelectorAll('.js-defer');

  if (imageElements.length > 0) {
    Array.forEach(imageElements, element => {
      ImageDeferrer.defer(element);
    });
  }
});
